const MobileStyle = () => {
    let contentlist = {
        viewStyle: "viewStyle"
    }
    return contentlist;
}

export { MobileStyle }